
import { useState } from "react";
import styles from "../FieldTypeModal.module.scss";
import { ChoseBoolFiledConfig } from "./shared/ChooseBool";
import Button from "../../../../../../../common/components/xepp/button/Button";
import { InputWithClearFiledConfig } from "./shared/InputWithClear";
import { Attribute, FieldType } from "../../../../../../../model/service-request/attribute";
import { v4 as uuidv4 } from 'uuid';

type Props ={
    onFieldSave: (attr: Attribute) => void
    existingAttribute?: Attribute
}

export const ToggleConfiguration = (props: Props) => {
    const [attribute, setAttribute] = useState<Attribute>({
        id: props.existingAttribute ? props.existingAttribute.id : uuidv4(),
        label:props.existingAttribute ? props.existingAttribute.label : "",
        placeholderText:props.existingAttribute ? props.existingAttribute.placeholderText : "",
        isRequired:props.existingAttribute ? props.existingAttribute.isRequired : false,
        isEnabled:props.existingAttribute ? props.existingAttribute.isEnabled : true,
        defaultState:props.existingAttribute ? props.existingAttribute.defaultState : true,
        fieldType: FieldType.Bool,
    });
    
    const clearFieldName = () =>
        setAttribute({ ...attribute, label: "" });


    return <div className={styles.rightSideBody}>
        <div className={styles.configurationForm}>
            <InputWithClearFiledConfig 
                onChange={(val:string)=>{
                        setAttribute({ ...attribute, label: val })
                }}
                onClear = {clearFieldName}
                value ={attribute.label}
                filedLabel="Field Name"
                placeholederText="Enter Field Name"
            />
            
            <ChoseBoolFiledConfig 
                onChange={(val: boolean) => {
                    setAttribute({ ...attribute, defaultState: val });
                    } 
                }
                value={attribute.defaultState ?? false}
                option1="On"
                option2="Off" 
                fieldLabel={"Default State"}
            />
        </div>
        <div className={styles.saveField}>
            <Button onClick={() => { props.onFieldSave(attribute); }} variant="secondary" text="Save Field" className={styles.saveFieldBtn} />
        </div>
    </div>
}